import "./index.css";
import BlockchainPortfolioRiskAnalyzer from "./BlockchainPortfolioRiskAnalyzer";

export function App() {
  return <BlockchainPortfolioRiskAnalyzer />;
}

export default App;
